<template>
  <div>
    <div class="section-1 container">
      <div class="content-padding section-1-right" id="how-it-works">
        <h1>Relaxy is a clinician-first health technology company that makes relaxation measurable.</h1>
        <p>We use validated skin conductance technology (electrodermal activity) to provide psychiatrists, psychologists, and related professionals with an objective, real-time signal of autonomic arousal. This enables clinicians to observe how a patient responds during therapy, identify patterns and triggers, and document progress over time—complementing clinical judgment and patient self-report.</p>
        <p>Relaxy is built around a medical-oriented sensor platform that captures rapid changes in emotional sweating driven by sympathetic nervous system activity. When arousal rises, the signal responds within seconds; when the patient settles, the signal decreases—creating a practical, quantitative "readout" of relaxation response. This turns relaxation from a subjective concept into a measurable, trainable capability.</p>
      </div>
      <div class="section-1-left">
        <img src="../assets/hugg.png" alt="" class="img">
      </div>
    </div>
    <div class="section-sea">
        <img src="../assets/sea.jpg" alt="" class="img hide-mobile">
        <img src="../assets/sea-small.jpg" alt="" class="img hide-desktop">
        <div class="section-2-content">
          <img src="../assets/relaxy-icon.svg" alt="" class="relaxy-icon-middle" >
        </div>
        <div class="section-sea-bottom">
          <div class="section-sea-bottom-content">
            <h1>Why now</h1>
            <p>Mental health providers are under growing pressure to deliver measurable outcomes and scalable care. Yet anxiety and stress response are still primarily assessed through conversation and questionnaires. Relaxy adds a physiological layer that supports more individualized treatment, clearer documentation, and stronger patient engagement—without requiring clinicians to change their therapeutic modality.</p>
          </div>
        </div>
      </div>
      <div class="section-mobile-sketches">
        <img src="../assets/mobile-sketches.png" alt="" class="img hide-mobile">
        <img src="../assets/mobile-sketches-mobile.png" alt="" class="img hide-desktop">
      </div>
      <div class="presenting-relaxy container">
        <div class="presenting-relaxy-section-1">
          <h1>What Relaxy enables (clinical value)</h1>
          <p><strong>Objective session insight:</strong> Real-time measurement of autonomic arousal during interventions (e.g., guided relaxation, exposure work, hypnosis, mindfulness-based approaches).</p>
          <p><strong>Better personalization:</strong> Helps clinicians identify what actually reduces arousal for a given patient and adjust treatment plans accordingly.</p>
          <p><strong>Progress tracking:</strong> Comparable session summaries and trends over time to support outcome documentation and decision-making.</p>
          <p><strong>Between-session training:</strong> Patients can practice at home with immediate biofeedback and return measurable results to therapy—supporting adherence and continuity of care.</p>
        </div>
        <div class="presenting-relaxy-section-1">
          <h1>Product concept</h1>
          <p>Relaxy combines:</p>
          <p><strong>A wearable skin conductance sensor</strong> designed for accurate, high-temporal-resolution monitoring, and</p>
          <p><strong>A companion software experience</strong> that supports guided sessions, optional prompts (including tactile feedback), and longitudinal reporting for both clinician review and patient motivation.</p>
        </div>
        <div class="presenting-relaxy-section-2">
          <img src="../assets/graph1.svg" alt="" class="img graph-img">
          <div class="presenting-relaxy-content">
            <h1>Business model direction</h1>
            <p>Relaxy is designed for a B2B2C model:</p>
            <p><strong>Primary customer:</strong> clinics and professionals (subscription/licensing + device deployment)</p>
            <p><strong>End user:</strong> patients (structured training and follow-up between sessions)</p>
            <p>This supports recurring revenue while driving improved clinical outcomes and retention through measurable progress.</p>
          </div>
        </div>

        <div class="presenting-relaxy-section-1">
          <h1>Partnership opportunity</h1>
          <p>Relaxy is positioned to integrate into existing care pathways and partner with:</p>
          <p>Mental health clinics and provider networks</p>
          <p>Digital therapeutics and care platforms</p>
          <p>Occupational health and stress-management programs</p>
          <p>Payers and employers seeking measurable mental health support</p>
          <p>Relaxy's mission is to bring objective biofeedback into mainstream mental healthcare—so clinicians can guide, measure, and scale effective relaxation training with confidence.</p>
        </div>
        <Mailchimp></Mailchimp> 
      </div>
      
    <div class="padding-mobile" id="footer">
      <img src="../assets/relaxy-icon.svg" alt="">
      <h2>We would like to talk to you!</h2>
      <p class="padding-5px">hanne@med-storm.com</p>
      <p class="padding-5px">Med-Storm Go AS</p>
      <p class="padding-5px">Org nr: 923 370 218</p>
      <p class="padding-5px">Tlf: +47 90 78 89 76</p>  
    </div>
  </div>

</template>

<script>

import Mailchimp from '@/components/Mailchimp'


export default {
  components: {
    Mailchimp
 }
}
</script>

<style scoped>

.section-1 {
  display: flex;
  flex-direction: column;
}

.section-1-left {
  margin-top: 100px;
}

.section-1-right {
  padding: 0 37px 0 37px;
  margin-top: 50px;
}

.section-sea {
  position: relative;
  display: block;
  overflow-x: hidden;

}

.relaxy-icon-middle {
  position: absolute;
  top: 16%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 125px;
}

.section-sea-bottom {
  bottom: 0;
  background-color: #fff;
  opacity: 0.8;
  width: 100%;
}

.section-sea-bottom-content {
  padding: 30px 37px 0 37px;
  }

  .section-mobile-sketches {
  position: static;
  margin-top: 50px;
  margin-bottom: 100px;
  
}

.section-mobile-sketches img {
  overflow: hidden;
}

.hide-mobile {
  display: none;
}

.presenting-relaxy {
  padding: 0 37px 0 37px;

}

.graph-img {
  margin-top: 20px;
}

.presenting-relaxy-section-2 {
  display: flex;
  flex-direction: column;
}

.no-margin {
  margin: 0 0 0 0;
  padding: 3px 0 3px 0;
}

 #footer {
  padding-top: 37px;
  padding-bottom: 37px;
  background: transparent linear-gradient(180deg, #637C85 0%, #34464D 100%) 0% 0% no-repeat padding-box;
  min-height: 300px;
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  text-align: center;
  color: #fff;
 }

 #footer h2 {
  font-weight: 300;
 }

.padding-5px {
  padding: 5px;
  margin: 0;
  font-weight: 300;
}

@media only screen and (min-width: 768px) {

    p {
          font-size: 22px;
      }

    .section-1 {
      display: flex;
      flex-direction: row-reverse;
    }
    .section-1-right {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-top: unset;
    }
    .section-1-left {
      width: 50%;
      padding: 0 37px 0 37px;
      display: flex;
      align-items: center;
      margin: 0;
    }
    .section-sea-bottom-content {
      max-width: 500px;
    }
    .section-sea-bottom {
      display: flex;
      justify-content: center;
    }
    .hide-desktop {
      display: none;
    }
    .hide-mobile {
      display: block;
    }

    .presenting-relaxy-section-1 {
      max-width: 1000px;
    }

    .presenting-relaxy-content {
      width: 60%;
      padding: 0 37px 0 0;

    }

    .presenting-relaxy-section-2 {
      display: flex;
      flex-direction: row-reverse;
      margin-top: 50px;
    }

    .graph-img {
      width: 40%;
      padding: 0 37px 0 37px;
    }

    .newsletter {
      max-width: 500px;
    }

  }

 @media only screen and (min-width: 1220px) {
   .section-1-left {
    padding: 0 100px 0 37px;
    }
  .section-1-right {
    padding: 0 100px 0 100px;
    }
  } 

   @media only screen and (min-width: 1440px) {
   .section-1-left {
    padding: 0 100px 0 0;
    }
  } 

</style>